import {PatientPhr} from './patient-phr.model';

export class PhrCategoryGroup {
  name: string;
  label: string;
  categoryArray: string[];
  active: boolean;
  elements: PatientPhr[];
}
